export default "__VITE_ASSET__CSyIk3mb__"